<template>
	<div class="modal-information">
		<div class="modal-information-logo">
			<img
				src="/static/images-new/logos/logo-casamarket-orange.svg"
				alt="logo casamarket"
				class="modal-information-image"
			/>
		</div>
		<p class="w-black newwarning--text modal-information-title">
			TU CLIENTE <span class="newprimary--text">CERCA DE TI</span>
			<br/> SIN QUE SALGA DE CASA
		</p>
		<p class="w-medium newinfo--text modal-information-subtitle">
			La primera app de pedidos para ayudar a los negocios en
			tiempos de coronavirus, acercando a clientes y negocios.
		</p>
		<div class="modal-information-btn">
			<v-btn
				class="btn-location"
				color="primary"
				@click="$emit('active-location')"
			>
				Haz clic aquí y usa tu ubicación
			</v-btn>
		</div>
		<div class="modal-information-searcher">
			<v-text-field
				prepend-icon="search"
				class="input-location input-location-primary"
				hide-details
				id="input-autocomplete-marketplace"
				placeholder="Buscar dirección"
				v-model="address"
				@input="$emit('get-address', $event)"
			></v-text-field>
		</div>
	</div>
</template>
<script>
function data() {
	return {
		address: '',
	};
}

export default {
	name: 'modal-step-one',
	data,
};
</script>
<style lang="scss" scoped>
	.modal-information {
		padding: 0px 16px;
		text-align: center;

		@media (min-width: 936px) {
			padding: 0px;
		}

		&-title {
			font-size: size(large);
			line-height: 30px;
			margin-bottom: 15px;

			@media (min-width: 936px) {
				font-size: size(large30);
				line-height: 41px;
				margin-bottom: 20px;
			}
		}

		&-subtitle {
			font-size: size(medium16);
			line-height: 20px;
			margin: 0px auto 30px;
			max-width: 306px;

			@media (min-width: 936px) {
				font-size: size(medium18);
				line-height: 23px;
				margin: 0px auto 38px;
				max-width: 479px;
			}
		}

		&-logo {
			margin-bottom: 27px;

			@media (min-width: 936px) {
				margin-bottom: 42px;
			}
		}

		&-image {
			height: 47px;

			@media (min-width: 936px) {
				height: 63px;
			}
		}
	}

	.btn-location {
		border-radius: 25px !important;
		color: color(white);
		font-size: size(medium16);
		font-weight: weight(black);
		height: 50px;
		margin: 0px 0px 10px !important;
		max-width: 326px;
		width: 100%;

		@media (min-width: 936px) {
			margin: 0px 0px 23px !important;
			max-width: 514px;
		}
	}

	.input-location {
		border: 1px solid color(primary);
		border-radius: 24px;
		height: 48px;
		margin: 0 auto;
		max-width: 326px;
		padding-left: 11px;
		padding-top: 0px;
		width: 100%;

		@media (min-width: 936px) {
			max-width: 514px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/modal-step-one.vue